import '@components/page-loader/PageLoader.scss';

const PageLoader = () => {
  return <div className="page-loader"></div>;
};
export default PageLoader;
